import { useCallback, useState } from 'react';
export const useAnimation = ({
  tx = 0,
  ty = 0,
  tz = 0,
  opacity: _opacity = 1,
  sx = 1,
  sy = 1,
  width: _width = 0
}) => {
  const [translate, setTranslate] = useState([tx, ty, tz]);
  const [opacity, setOpacity] = useState(_opacity);
  const [scale, setScale] = useState([sx, sy]);
  const [width, setWidth] = useState(_width);
  const start = useCallback(({
    tx,
    ty,
    tz,
    opacity,
    sx,
    sy,
    width
  }) => {
    setTranslate([tx, ty, tz]);
    setOpacity(opacity);
    setScale([sx, sy]);
    setWidth(width);
  }, []);
  return [{
    tx: translate[0],
    ty: translate[1],
    tz: translate[2],
    opacity,
    sx: scale[0],
    sy: scale[1],
    width
  }, start];
};